import { alpha, Button, CircularProgress, useColorScheme } from "@mui/material";
import { Constants } from "../../utils/constants";


export default function ErrorButton({
  text,
  size = "large",
  preIcon = null,
  type = "button",
  fullWidth = true,
  onClick = () => { },
  disabled = false,
  isSubmitting = false,
  sx,
}) {
  const { mode } = useColorScheme();
  const currentMode = mode || "light";
  return (
    <Button
      onClick={isSubmitting ? () => { } : onClick}
      size={size}
      variant="contained"
      startIcon={preIcon}
      disabled={disabled}
      fullWidth={fullWidth}
      type={type}
      sx={{
        backgroundColor: "transparent",
        color: Constants.Colors[currentMode].destructive,
        borderRadius: "6px",
        boxShadow: "none",
        textTransform: "none",
        fontWeight: Constants.Styles.fontWeight.semiBold,
        border: `1px solid ${Constants.Colors[currentMode].destructive}`,
        "&:hover": {
          boxShadow: "none",
          backgroundColor: alpha(Constants.Colors[currentMode].secondary, 0.9),
          // color: alpha(Constants.Colors[currentMode].accentForeground, 0.5),
        },
        ...sx,
      }}
    >
      {isSubmitting ? <CircularProgress color="success" size={20} /> : text}
    </Button>
  );
}